<script lang="ts">
export default {
  name: 'KkProductPreviewModal',
}
</script>
<script setup lang="ts" >
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { KkModal, KkButton, KkBox, KkLoading } from '../../../../components/base'
const store = useStore()
const { t } = useI18n()

const productStores = computed(() => store.getters['companiesProduct/productStores'])
const productLoading = computed(() => store.getters['companiesProduct/loading'])
interface Image {
  url: string
  id: number
  name: string
}
interface Props {
  isVisible: boolean
  images: Image[]
  productName: string
  categoryName: string
  productPrice?: string
  productDescription?: string
  optionButtonUrl?: string
}
const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
  images: () => [],
  productName: '',
  categoryName: ''
})
const emit = defineEmits(['submit', 'close'])
</script>

<template>
  <KkModal :is-visible="props.isVisible" width="720px" @change="emit('close')">
    <KkLoading v-if="productLoading" />
    <div v-if="!productLoading">
      <div class="p-modal__content__header">
        {{ t('pages.CompaniesProductNew.form.preview.title') }}
      </div>
      <div class="p-modal__content__body">
        <KkBox tag="div" shadow>
          <template #content>
            <div class="productInfo">
              <div v-for="image in props.images" :key="image.id" class="productInfo__image__wrapper">
                <img :src="image.url" :alt="image.name" class="productInfo__image">
              </div>
              <div class="productInfo__detail">
                <div class="productInfo__name">{{ productName }}</div>
                <div class="productInfo__category">{{ categoryName }}</div>
                <div v-if="productDescription" class="productInfo__description">{{ productDescription }}</div>
                <div v-if="productPrice" class="productInfo__price">{{ Number(productPrice).toLocaleString() }}円</div>
              </div>
            </div>
          </template>
        </KkBox>
        <div v-if="productStores.length" class="productTable">
          <div class="productTable__title">{{ t('pages.CompaniesProductNew.form.preview.buttonUrl') }}</div>
          <div class="p-table__content">
            <table>
              <thead>
                <tr>
                  <th class="productTable__storeName">{{ t('pages.CompaniesProductNew.form.preview.storeName') }}</th>
                  <th class="productTable__url">{{ t('pages.CompaniesProductNew.form.preview.url') }}</th>
                </tr>
                <tr class="p-table__content__space">
                  <td colspan="4" />
                </tr>
              </thead>
              <tbody>
                <tr v-for="value in productStores" :key="value.storeUuid">
                  <td>{{ value.storeName }}</td>
                  <td>{{ value.optionButtonUrl }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="p-modal__content__footer">
        <div class="c-button c-button--right">
          <KkButton
            class="footerCancelBtn"
            color="secondary"
            outlined
            :text="t('labels.close')"
            @click="emit('close')"
          />
          <KkButton
            color="primary"
            outlined
            :text="t('labels.confirm')"
            @click="emit('submit')"
          />
        </div>
      </div>
    </div>
  </KkModal>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.productInfo {
  display: flex;

  &__image__wrapper {
    flex: none;
    width: calc(176px + 24px);
    height: calc(176px + 40px);
    padding-bottom: 40px;
    padding-right: 24px;
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    margin-bottom: 8px;
    object-fit: cover;
    border: 1px solid #E3E3E3;
    border-radius: 4px;
  }

  &__name {
    font-size: 14px;
    font-weight: bold;
  }

  &__category {
    font-size: 12px;
  }

  &__description {
    margin-top: 16px;
    font-size: 12px;
    opacity: 0.7;
  }

  &__price {
    font-size: 12px;
    font-weight: bold;
  }

  &__action
  {
    &__button {
      display: inline-block;
      margin-top: 8px;
      padding: 4px 16px;
      color: #ffffff;
      background-color: #1A73E8;
      border-radius: 4px;
      text-decoration: none;
      font-size: 12px;
    }
  }
}
.productTable {
  &__title {
    font-size: 12px;
    font-weight: bold;
    margin: 24px 0;
  }
  height: 100%;
  &__storeName {
    width: 50%;
  }
  &__url {
    width: 50%;
  }
  td:empty {
    display: table-cell;
  }
}

.footerCancelBtn {
  margin-right: 8px;
}
</style>
